// System Designer (Android DashboardFragment "System Designer" → SalesItemListFragment) — same endpoints as the
// Android technician app (api/v3/pro). Every call resolves to { ok, body, message, activeRecord } and never throws.
import { apiCall } from "./apiCall";

// spa/consumer-detail (Your Home / Your Summary) carries the pro token from the `_token` param, like Android sends it
const proToken = () => {
  try {
    return JSON.parse(localStorage.getItem("user"))?._token || "";
  } catch (e) {
    return "";
  }
};

export const systemDesignerApi = {
  // one active job at a time (Android checkSingleActiveRecordThenSubmitPerfectMatch)
  singleActiveRecord: () => apiCall("get", "single-active-record"),
  // { our_purpose, our_promise, our_approach, our_product, your_home: { init, fail, success }, your_summary: {…}, is_shop_available }
  // bookingId: Android JobLandingFragment "Installation Pricing" (StaticUrlController reads booking_id for the quote params)
  presentation: (bookingId) => apiCall("get", "sales/presentation", bookingId
    ? { _token: proToken(), booking_id: bookingId }
    : { _token: proToken() }),
  // Our Product: { banners: [url] } or { video: url }, plus pdf: [{ title, value }]
  banner: () => apiCall("get", "sales/banner"),
  // Our Promise customer reviews: [{ consumer_name, review, consumer_picture, rating }]
  reviews: () => apiCall("get", "reviews/list"),
};
